import type { Nullable } from '@src/shared/types/common';

function getTextFromComboBox(labelName: string) {
    const label = `#${labelName}`;
    return $(label).data('kendoComboBox')?.text();
}

function setTextToComboBox(labelName: string, text: string) {
    const label = `#${labelName}`;
    const instance = $(label).data('kendoComboBox');

    instance?.text(text);
    instance?.value(text);
}

function closeComboBox(combobox: kendo.ui.ComboBox) {
    combobox.input.trigger('blur');
}

function comboAutoSelectFirst(combo: kendo.ui.ComboBox | undefined) {
    combo?.bind('dataBound', ({ sender }: kendo.ui.ComboBoxDataBoundEvent) => {
        if (sender.dataSource.data().length === 1) {
            sender.select(0);
            sender.trigger('change');
        }
    });
}

function changeKendoComboBox(
    combobox: kendo.ui.ComboBox,
    value: string,
    text: string,
    disable: boolean = false
) {
    if (combobox.value() !== value.toString()) {
        combobox.value(value);
        if (text) {
            combobox.text(text);
        }
        combobox.trigger('change');

        if (disable) {
            setTimeout(() => {
                combobox.enable(false);
            }, 2000);
        }
    }
}

function comboClearItems(combo: kendo.ui.ComboBox) {
    if (combo.dataSource.total() > 0) {
        const items = combo.dataSource.data();
        for (let i = 0; i < combo.dataSource.total(); i++) {
            combo.dataSource.remove(items[i]);
        }
    }
}

function selectItem(combo: kendo.ui.ComboBox | undefined, value: Nullable<kendo.data.Model> | undefined) {
    if (combo) {
        if (!value || value.Text.length === 0) {
            combo.select(-1);
            return;
        }

        if (combo.dataSource.data().map((i: { Id: number }) => i.Id).includes(value.Id)) {
            combo.value(String(value.Id));
            return;
        }

        if (value.Code) {
            value.Text = `${value.Code}. ${value.Text}`;
        }

        combo.dataSource.insert(0, value);
        combo.value(String(value.Id));
    }
}

function cleanRebind(controlName: string) {
    const control = $(`#${controlName}`).data('kendoComboBox');
    if (!control) {
        return;
    }
    control.value('');
    window.rebindDataSource(control);
}

function comboPlusRedirect(name: string, template: string) {
    const combo = $(`#${name}`).data('kendoComboBox');
    const dataItem = combo?.dataItem();
    const value = parseInt(combo?.value() ?? '');
    const id = dataItem ? (dataItem.Id || dataItem.Value) : value;

    if (id) {
        const url = template.replace('{0}', id.toString());
        window.open(url);
    }
}

function bindMfiControl(combo: string, mfiCombo: string) {
    if (!combo || !mfiCombo) {
        return;
    }
    const cmb = $(`#${combo}`).data('kendoComboBox');
    const mfi = $(`#${mfiCombo}`).data('kendoComboBox');
    const dataItem = cmb?.dataItem();
    if (!dataItem) {
        return;
    }
    const moneyFlowItemId = dataItem.MoneyFlowItemId;
    if (!moneyFlowItemId) {
        return;
    }
    mfi?.value(moneyFlowItemId);
}

function dynamicComboBoxFilter(
    e: kendo.ui.ComboBoxFilteringEvent,
    comboId: string,
    additionalParams?: () => Record<string, unknown>
) {
    let txt = '';

    if (e.filter && e.filter.filters[0]) {
        txt = e.filter.filters[0].value;
    }
    else if (comboId) {
        comboId = comboId.replace(/\./g, '_');
        const combo = $(`#${comboId}`).data('kendoComboBox');
        if (combo) {
            txt = combo.value();
        }
    }

    const result = additionalParams?.() ?? {};
    result.text = txt;
    return result;
}

function cascadeOfTwoComboBoxInit(firstCombo: kendo.ui.ComboBox, secondCombo: kendo.ui.ComboBox) {
    if (firstCombo.value()) {
        secondCombo.enable(true);
        window.rebindDataSource(secondCombo);
    }
    else {
        secondCombo.enable(false);
    }
}

function cascadeOfThreeComboBoxInit(firstCombo: kendo.ui.ComboBox, secondCombo: kendo.ui.ComboBox, thirdCombo: kendo.ui.ComboBox) {
    if (firstCombo.value()) {
        secondCombo.enable(true);
        window.rebindDataSource(secondCombo);
    }
    else {
        secondCombo.enable(false);
        thirdCombo.enable(false);
    }
}

function cascadeOfFourComboBoxInit(
    firstCombo: kendo.ui.ComboBox,
    secondCombo: kendo.ui.ComboBox,
    thirdCombo: kendo.ui.ComboBox,
    fourthCombo: kendo.ui.ComboBox
) {
    if (firstCombo.value()) {
        secondCombo.enable(true);
        window.rebindDataSource(secondCombo);
    }
    else {
        secondCombo.enable(false);
        thirdCombo.enable(false);
        fourthCombo.enable(false);
    }
}

function getDataValueCombobox(combobox: kendo.ui.ComboBox) {
    return combobox.element.attr('data-val');
}

function updateDataValueCombobox(combobox: kendo.ui.ComboBox) {
    combobox.element.attr('data-val', combobox.value());
}

window.bindMfiControl = bindMfiControl;
window.cascadeOfThreeComboBoxInit = cascadeOfThreeComboBoxInit;
window.getTextFromComboBox = getTextFromComboBox;
window.cascadeOfFourComboBoxInit = cascadeOfFourComboBoxInit;
window.changeKendoComboBox = changeKendoComboBox;
window.cleanRebind = cleanRebind;
window.cascadeOfTwoComboBoxInit = cascadeOfTwoComboBoxInit;
window.closeComboBox = closeComboBox;
window.comboAutoSelectFirst = comboAutoSelectFirst;
window.comboClearItems = comboClearItems;
window.comboPlusRedirect = comboPlusRedirect;
window.selectItem = selectItem;
window.dynamicComboBoxFilter = dynamicComboBoxFilter;
window.getDataValueCombobox = getDataValueCombobox;
window.updateDataValueCombobox = updateDataValueCombobox;
window.setTextToComboBox = setTextToComboBox;
